import { useCallback } from 'react';

import { useSessionStopped } from './useSessionStopped/useSessionStopped';

export const useSessionResume = (
    play: () => void,
    sessionInfo: ReturnType<typeof useSessionStopped>
) => {
    const { reset } = sessionInfo;

    return useCallback(() => {
        reset();
        play();
    }, [play, reset]);
};
